export const CREATE_MEDIA_ITEM = "CREATE_MEDIA_ITEM";
export const DELETE_MEDIA_ITEM = "DELETE_MEDIA_ITEM";
export const UPDATE_MEDIA_ITEM = "UPDATE_MEDIA_ITEM";
